import React, { Component } from 'react';

import ReactDropdown from "react-dropdown";

import styles from 'editor/workspace/window/titlebar/titleBar.module.scss';
import {Context} from "context";

class WindowOptions extends Component {
    static contextType = Context;

    // todo - Comment needed for this function
    updateWindow(name, event) {
        this.props.updateWindow({
            target: {
                name: name,
                value: event.value
            }
        })
    }

    render() {
        return (
            <div className={styles.viewOptions}>
                <div data-hint={this.context.text.hints.versionToggle}>
                    <ReactDropdown
                        className="highlightSecondary"
                        menuClassName="bgSecondary highlightSecondary"
                        options={[
                            {value:"original", label: "Original"},
                            {value:"uploaded", label: "Uploaded"},
                            {value:"modified", label: "Modified"}
                        ]}
                        value={this.props.valueType}
                        onChange={this.updateWindow.bind(this, "valueType")}
                    />
                </div>
                <div data-hint={this.context.text.hints.valueDiffToggle}>
                    <ReactDropdown
                        className="highlightSecondary"
                        menuClassName="bgSecondary highlightSecondary"
                        options={[
                            {value: "actual", label: "Actual"},
                            {value: "relative", label: "Relative"},
                            {value: "percentage", label: "Percentage"}
                        ]}
                        value={this.props.diffType}
                        onChange={this.updateWindow.bind(this, "diffType")}
                    />
                </div>
                <div data-hint={this.context.text.hints.layoutToggle}>
                    {this.props.table.dimension > 1 ?
                        <ReactDropdown
                            className="highlightSecondary"
                            menuClassName="bgSecondary highlightSecondary"
                            options={[
                                {value: "sheet", label: "Table Only"},
                                {value: "visual", label: "Visual Only"},
                                {value: "both", label: "Table + Visual"}
                            ]}
                            value={this.props.viewMode}
                            onChange={this.updateWindow.bind(this, "viewMode")}
                        />
                        :
                        <ReactDropdown
                            className="highlightSecondary"
                            menuClassName="bgSecondary highlightSecondary"
                            options={[
                                {value: "sheet", label: "Table Only"}
                            ]}
                            value={this.props.viewMode}
                            disabled={true}
                            onChange={this.updateWindow.bind(this, "viewMode")}
                        />
                    }
                </div>
            </div>
        )        
    }
}

export default WindowOptions;
